import React from "react";
import SortlistedCandidates from "../sortlistedCandidates";
import { constants } from "../../../../constants/common";
const LevelTwo = () => {
    return <SortlistedCandidates level={constants.PROFILE_STATUS.LEVEL_2} />
}

export default LevelTwo;